import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import { useLanguage } from "context/LanguageContext";
import macbook from "assets/images/macbook.png";

function Newsletter() {
  const { messages } = useLanguage();

  return (
    <MKBox component="section" pt={4} pb={8}>
      <Container>
        <Grid container alignItems="center" spacing={4}>
          <Grid item xs={12} md={6} sx={{ ml: { xs: 0, lg: 3 } }}>
            <MKTypography variant="h4" mb={1}>
              {messages.constructionPage.cta.title}
            </MKTypography>
            <MKTypography variant="body2" color="text" mb={3}>
              {messages.constructionPage.cta.description}
            </MKTypography>
            <MKButton
              variant="gradient"
              color="info"
              component="a"
              href="/pages/landing-pages/contact-us"
            >
              {messages.constructionPage.cta.action}
            </MKButton>
          </Grid>
          <Grid item xs={12} md={5} sx={{ ml: "auto" }}>
            <MKBox position="relative">
              <MKBox component="img" src={macbook} alt="construction-dashboard" width="100%" />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Newsletter;
